import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Encabezado } from './Encabezado';
import { FomularioReceptor } from './FormularioReceptor';
import { CapturaTickets } from './CapturaTickets';

import instanciaAxios from '../../servicios/InterceptorAxios';
import { esObjetoVacio } from '../../servicios/ServicioObjetos';
import servicioDescargaArchivos from '../../servicios/ServicioDescargaArchivos';

export const FacturacionNru = (props) => {
    const { titulo, urlConsultaUsoCfdi, urlConsultaRegimen, urlValidacionNru,
        urlConsultaNru, autenticado, urlEliminarCruces, urlGenerarFactura,
        urlValicacionReceptor, urlDescargaArchivos } = props;
    const [receptor, setReceptor] = useState({
        // rfc: 'CACM900228LE4',
        // nombre: "MARCO ANTONIO CARRASCO COMONFORT"
    });
    const [erroresReceptor, setErroresReceptor] = useState({});
    const [nrus, setNrus] = useState([]);
    const [resultados, setResultados] = useState([]);
    const [mostrarModal, setMostrarModal] = useState(false);

    useEffect(() => {
        buscarCrucesSinRegistro();
    }, [autenticado]);

    const buscarCrucesSinRegistro = () => {
        instanciaAxios.post(urlConsultaNru).then(response => {
            setNrus(response.data);
        }).catch(error => {

        });
    }

    const facturar = () => {
        const validacionReceptor = validarReceptor();
        setErroresReceptor(validacionReceptor);
        if (esObjetoVacio(validacionReceptor)) {
            const receptorEnvio = { ...receptor };
            receptorEnvio.regimenFiscalReceptor = receptor.regimenFiscal.id;
            receptorEnvio.usoCFDI = receptor.usoCfdi.id;
            delete receptorEnvio.correo;
            delete receptorEnvio.regimenFiscal;
            delete receptorEnvio.usoCfdi;
            instanciaAxios.post(urlValicacionReceptor, receptorEnvio).then(response => {
                if (response.data.error) {
                    let listaResultados = [];
                    listaResultados.push({
                        error: true,
                        uuid: response.data.mensaje
                    });
                    setMostrarModal(true);
                    setResultados(listaResultados);
                } else {
                    facturarNru();
                }
            }).catch(error => {

            });
        }
    }

    const facturarNru = () => {
        const receptorFacturar = {};
        receptorFacturar.rfc = receptor.rfc;
        receptorFacturar.nombre = receptor.nombre;
        receptorFacturar.correo = receptor.correo;
        receptorFacturar.domicilioFiscalReceptor = receptor.domicilioFiscalReceptor;
        receptorFacturar.regimenFiscalReceptor = receptor.regimenFiscal.id;
        receptorFacturar.usoCfdi = receptor.usoCfdi.id;
        instanciaAxios.post(urlGenerarFactura, receptorFacturar).then(response => {
            let listaResultados = response.data;
            setResultados(listaResultados);
            setMostrarModal(true);
            buscarCrucesSinRegistro();
        }).catch(error => {
            buscarCrucesSinRegistro();
        });
    }

    const cerrarModal = () => {
        setMostrarModal(false);
    }

    
    const descargaArchivos = (rowData) => {
        if (!esObjetoVacio(rowData.busqueda))
            servicioDescargaArchivos.descargaArchivo(urlDescargaArchivos, { id: rowData.busqueda });
    }

    const templateDescargaArchivos = (rowData, column) => {
        return esObjetoVacio(rowData.busqueda) ? null : <div>
            <Button type="button" icon="pi pi-download" className="p-button-success" onClick={(e) => descargaArchivos(rowData)}></Button>
        </div>;
    }

    const validarReceptor = () => {
        let errores = {};

        if (!receptor.rfc)
            errores.rfc = "El rfc del receptor es requerido";
        if (!receptor.nombre)
            errores.nombre = "La razón social es requerido"

        if (!receptor.regimenFiscal)
            errores.regimenFiscal = "El regimen Fiscal es requerido"
        if (!receptor.usoCfdi) {

            errores.usoCfdi = "El uso Cfdi es requerido";
        }
        if (!receptor.domicilioFiscalReceptor)
            errores.domicilioFiscalReceptor = "El domicilio fiscal receptor es requerido";

        
            var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            var validacionCorreo = null;
            if (receptor.correo) {
                const validacionesCorreos = receptor.correo.split(",");
                var i = 0;
                for (i = 0; i < validacionesCorreos.length; i++) {
                    const valorvalidacion = expreReg.exec(validacionesCorreos[i]);
                    if (valorvalidacion == null)
                        validacionCorreo += "El correo : " + validacionesCorreos[i] + " no es un correo. "
                }
            }
            if (!receptor.correo)
                errores.correo = "El correo es requerido";
            if (validacionCorreo)
                errores.correo = "Ingrese un correo valido"
            if (validacionCorreo != null && validacionCorreo.includes("El correo :"))
                errores.correo = validacionCorreo.replace("null", "");
              
        return errores;
    }

    const piePaginaModalRestultados = (
        <div>
            <Button label="Cerrar" icon="pi pi-times" onClick={cerrarModal} />
        </div>
    );

    return (
        <div>
            <div className="p-fluid">
                <Encabezado titulo={titulo} />
                <FomularioReceptor receptor={receptor} setReceptor={setReceptor}
                    erroresForm={erroresReceptor} urlConsultaUsoCfdi={urlConsultaUsoCfdi} 
                    urlConsultaRegimen={urlConsultaRegimen} />
                <CapturaTickets urlValidacionNru={urlValidacionNru} funcionBusquedaNru={buscarCrucesSinRegistro}
                    nrus={nrus} urlEliminarCruces={urlEliminarCruces} />
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-4"></div>
                        <div className="p-col-12 p-md-4">
                            {nrus.length > 0 ? <Button onClick={facturar} label="Facturar conceptos" className="p-button-rounded p-button-info" /> : null}</div>
                        <div className="p-col-12 p-md-4"></div>
                    </div>
                </div>
                <Dialog header="Resultado facturación" visible={mostrarModal} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={cerrarModal}>
                    <DataTable value={resultados} header="Facturas generadas" responsive={true}>
                        <Column field="uuid" header="UUID| Mensaje Error" />
                        <Column field="serie" header="Serie" />
                        <Column field="folio" header="Folio" />
                        <Column body={templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
                    </DataTable>
                </Dialog>
            </div>
        </div>
    );
}